import {
  Dialog,
  Box,
  DialogContent,
  DialogContentText,
  Typography,
  Button,
  DialogActions,
  DialogTitle,
} from "@mui/material";
import { UseDeliverycalendar } from "./UseDeliverycalendar";
import { useEffect, useState } from "react";

export default function ChangeParts(props) {
  const { getCalendardays, setDeliveryTimes } = UseDeliverycalendar();
  const [data, setData] = useState([]);
  const [openDialog, setOpenDialog] = useState({
    show: false,
    sendModel: undefined,
  });

  return (
    <>
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        // maxWidth="xs"
        open={openDialog.show}
        onClose={() => setOpenDialog({ ...openDialog, show: false })}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle color="red" id="alert-dialog-title">
          توجه!
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            آیا از {openDialog.name} بازه اطمینان دارید ؟
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ color: "#565656 !important" }}
            onClick={() => {
              setDeliveryTimes(openDialog.sendModel, () => {
                props.callback(props.selectedMonth);
                props.setChangeState({ ...props.changeState, show: false });
                setOpenDialog({ ...openDialog, show: false });
              });
            }}
          >
            بله
          </Button>
          <Button
            color="secondary"
            onClick={() => setOpenDialog({ ...openDialog, show: false })}
          >
            خیر
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        maxWidth="xs"
        open={props.changeState.show}
        onClose={() =>
          props.setChangeState({ ...props.changeState, show: false })
        }
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.changeState.dayname} {props.changeState.day} {props.dayName}
          </DialogContentText>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2, my: 2 }}>
            {props.changeState.model.map((parts) => {
              return (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography variant="subtitle2">
                    {parts.partname} :{" "}
                  </Typography>
                  <Typography sx={{ mx: 3 }} variant="subtitle2">
                    {parts.state == true ? "فعال" : "بسته"}
                  </Typography>

                  {parts.state == false ? (
                    <Button
                      onClick={() => {
                        setOpenDialog({
                          show: true,
                          sendModel: {
                            dayDate: props.changeState.dayDate,
                            deliveryType: props.selectedMonth.deliveryType,
                            part: parts.part,
                            state: true,
                          },
                          name: "فعال کردن",
                        });
                      }}
                      color="success"
                      variant="contained"
                    >
                      فعال
                    </Button>
                  ) : (
                    <Button
                      onClick={() => {
                        setOpenDialog({
                          show: true,
                          sendModel: {
                            dayDate: props.changeState.dayDate,
                            deliveryType: props.selectedMonth.deliveryType,
                            part: parts.part,
                            state: false,
                          },
                          name: "بستن",
                        });
                      }}
                      color="error"
                      variant="contained"
                    >
                      بسته
                    </Button>
                  )}
                </Box>
              );
            })}
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              onClick={() =>
                props.setChangeState({ ...props.changeState, show: false })
              }
              variant="outlined"
            >
              لغو{" "}
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}
